var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement("path", { d: "M6.5 7.326v9.68A2.504 2.504 0 0 0 9.001 19.5h6.998c.252 0 .497-.038.727-.108l.018.258a2.002 2.002 0 0 1-1.865 2.127l-7.963.557a2.001 2.001 0 0 1-2.143-1.847l-.768-10.99A2.002 2.002 0 0 1 5.869 7.37l.631-.044zM8 4.992C8 3.892 8.902 3 10.009 3h7.982C19.101 3 20 3.893 20 4.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2.001 2.001 0 0 1 8 16.008V4.992z", id: "navbar-doubletake" })
    ),
    React.createElement("use", { fill: "#e4edfd", xlinkHref: "#navbar-doubletake", fillRule: "evenodd" })
  );
});


// WEBPACK FOOTER //
// ./src/shared/components/NavBar/icons/DoubleTake.svg